import $ from 'jquery';

import App from 'libs/app';

App.registerReadyHandler("accessibility-reveal", function () {
    let $hide = $("body").children("*:not(.reveal-overlay)");
    $(window).on('open.zf.reveal', function () {
        $hide.attr("aria-hidden", true);
    });

    $(window).on('closed.zf.reveal', function () {
        $hide.attr("aria-hidden", false);
    });
});
